import React from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import style from "./Modal.module.scss";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";

export const IdleTimeOutModal = ({ showModal, handleContinue, handleLogout, remainingTime }) => {

    return (
        <Modal size="lg" show={showModal} onHide={handleContinue} contentClassName={style.todisModalContainer}
            className={style.todisModalContainer} aria-labelledby="contained-modal-title-vcenter" backdrop="static">
            <Modal.Header className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>You have been inactive</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    Your session is Timed Out Due to Inactivity.
                    <div className="todis-action-form mt-5">
                        {/* <Button variant="outline-danger" onClick={handleLogout} className={style.todisBtnOutline}>LOGOUT </Button> */}
                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{ margin: "0.5rem" }} onClick={handleLogout}>LOGIN AGAIN <BsArrowRight className="ms-2" size={20} /></Button>
                    </div>
                </Container>

            </Modal.Body>
            {/* <Button variant="danger" onClick={handleLogout}>
                Logout
            </Button>
            <Button variant="primary" onClick={handleContinue}>
                Continue Session
            </Button> */}

        </Modal>
    )
}